import {
  AudioField,
  CheckinField,
  CheckoutField,
  NoteField,
  PictureField,
  SignatureField,
  StatusField,
  TypeField,
} from './fields'
import { form } from './formState'
import { useAddFormMutations } from './hooks/useAddFormMutations'
import { useTexts } from './hooks/useTexts'
import { DriverAssistanceFormAlert } from './DriverAssistanceFormAlert'

export function FormContent() {
  const texts = useTexts()
  useAddFormMutations()

  const type = form.useFormField('type')

  const isSuggestMode =
    type.field.value === 'ASSISTED_TIME_OUT' || type.field.value === 'ASSISTED_TIME_IN_OUT'
  const isRequireMode = type.field.value === 'DRIVER_REQUIRED_FLOW'
  const alertType = isRequireMode ? 'require' : isSuggestMode ? 'suggest' : 'off'

  return (
    <>
      <TypeField />

      <form.Fieldset spacing={1}>
        {(isSuggestMode || isRequireMode) && (
          <form.Fieldset spacing={0}>
            <form.SectionTitle variant="alternative">{texts.actionTitle}</form.SectionTitle>
            <form.SectionSubtitle>
              {isSuggestMode ? texts.actionDescriptionSuggest : texts.actionDescriptionRequire}
            </form.SectionSubtitle>
          </form.Fieldset>
        )}

        {isSuggestMode && (
          <form.Fieldset spacing={1} paddingLeft={1}>
            <CheckinField />
            <CheckoutField disabled={true} />
          </form.Fieldset>
        )}

        {isRequireMode && (
          <form.Fieldset spacing={1} paddingLeft={1}>
            <CheckinField disabled={true} helperText={texts.helperText} />
            <StatusField />
            <PictureField />
            <SignatureField />
            <AudioField />
            <NoteField />
            <CheckoutField helperText={texts.helperText} />
          </form.Fieldset>
        )}

        <form.Fieldset>
          <DriverAssistanceFormAlert type={alertType} />
        </form.Fieldset>
      </form.Fieldset>
    </>
  )
}
